import { http } from '@/apis/aipass'
import { globalHotelId } from '@/hooks/use-hotel-id'
import { env } from '@/libs/env'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { CancelSpaceReservationResponse } from './space-reservation-types'

export const cancelSpaceReservation = createAsyncThunk<
  CancelSpaceReservationResponse,
  string,
  { rejectValue: unknown }
>(
  'space/cancelSpaceReservation',
  async (reservationId: string, { rejectWithValue }) => {
    try {
      const response = await http<CancelSpaceReservationResponse>({
        method: 'post',
        url: `${env('BASE_API_V3')}/guest/spaces/reservations/${reservationId}/cancel`,
        params: { hotelId: globalHotelId() },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

const spaceReservationCancelSlice = createSlice({
  name: 'spaceReservationCancel',
  initialState: {
    loading: false,
    error: null as unknown | null,
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(cancelSpaceReservation.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(cancelSpaceReservation.fulfilled, (state) => {
      state.loading = false
      state.error = null
    })
    builder.addCase(cancelSpaceReservation.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload ?? null
    })
  },
})

export const spaceReservationCancelReducer = spaceReservationCancelSlice.reducer
